import { render } from "./Public_Tickets.vue?vue&type=template&id=decd6b3e"
import script from "./Public_Tickets.vue?vue&type=script&lang=js"
export * from "./Public_Tickets.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__